// URL base da API PHP.
// ⚠️ Hoje o backend está na pasta ANINHADA no servidor (app_lizzi_fa/app_lizzi_fa).
// Quando você "achatar" a pasta para ficar só /app_lizzi_fa/, troque para:
//   'https://alexios.com.br/app_lizzi_fa'
// Em dev dá para sobrescrever com REACT_APP_API_BASE no .env.local
export const API_BASE: string =
  process.env.REACT_APP_API_BASE || 'https://alexios.com.br/app_lizzi_fa/app_lizzi_fa';

// Contato exibido na landing (CTA WhatsApp). Número oficial: +55 19 99802-8779.
export const WHATSAPP_CONTATO = '5519998028779';

// E-mail de contato exibido na landing e nas páginas legais.
export const EMAIL_CONTATO = 'contato@manuxservice.com.br';

export const INSTAGRAM_URL =
  process.env.REACT_APP_INSTAGRAM_URL || 'https://www.instagram.com/manux_services?stkn=MXYzZm04eTB2dGkxaw==';
